jQuery(document).foundation();

jQuery('[data-curtain-menu-button]').click(function(){
  jQuery('body').toggleClass('curtain-menu-open');
})